module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity9.d0988b69.jpg";